import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { ExpenditureItemMajorMatterForm } from './ExpenditureItemMajorMatterForm';

type Props = ComponentProps<typeof ExpenditureItemMajorMatterForm>;

export const ExpenditureItemMajorMatterFormDrawer: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={
        drawerState.open && drawerState.type === 'expenditure-item-major-matter'
      }
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      <ExpenditureItemMajorMatterForm
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Drawer>
  );
};
